var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spin-container"},[_c('div',{staticClass:"spin",attrs:{"id":"loader"}}),_c('div',{staticClass:"spin",attrs:{"id":"loader2"}}),_c('div',{staticClass:"spin",attrs:{"id":"loader3"}}),_c('div',{staticClass:"spin",attrs:{"id":"loader4"}}),_c('span',{attrs:{"id":"text"}},[_vm._v("CARGANDO...")])])
}]

export { render, staticRenderFns }